import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member";

type getBenefitSpecificEnrollmentInsightsAPIProps = {
	group_number: number;
	enrollment_type: string;
	plan_name: string;
};
export const getBenefitSpecificEnrollmentInsights = async (
	_apiPayload: getBenefitSpecificEnrollmentInsightsAPIProps
) => {
	const { group_number, enrollment_type, plan_name } = _apiPayload;
	try {
		const endpoint = `${initialRoute}/benefit-summary/specific-enrollment-details-insights?group_number=${group_number}&enrollment_type=${enrollment_type}&plan_name=${plan_name}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			// alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			// alert(message);
		} else {
			throw error;
		}
	}
};
